module.exports = __webpack_public_path__ + "img/personCircle.17542a9a.svg";